module.exports = __webpack_public_path__ + "img/people-19-min.bac88010.png";